import { useState, useEffect } from "react";
import API from "../../../../services/API";

export default function useMoneyMovements({ userId, planExecutionId }) {
    const [moneyMovements, setMoneyMovements] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getMoneyMovements();
    }, [userId, planExecutionId]);

    const getMoneyMovements = async () => {
        try {
            setLoading(true);
            const res = await API.getMoneyMovements({ userId, planExecutionId });
            setMoneyMovements(res || []);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }

    return {
        moneyMovements,
        loading,
        getMoneyMovements
    };
}
